class StringUtils {

    static isBlank(str) {
        return (!str || /^\s*$/.test(str));
    }

    static isEmail(str) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(str));
    }

    static formatDateTime(date) {
        if (!date) {
            return '';
        }
        let d = typeof date === 'string' ? new Date(date) : date;

        const formatNumber = (num) => String(num).padStart(2, '0');

        return `${formatNumber(d.getDate())}/${formatNumber(d.getMonth() + 1)}/${d.getFullYear()} ` +
            `${formatNumber(d.getHours())}:${formatNumber(d.getMinutes())}:${formatNumber(d.getSeconds())}`;
    }
}

export default StringUtils;